export default "__VITE_ASSET__BumYlh1p__"